// Bet odds / rate se bekaar trailing zeros hatao: DB DECIMAL(10,4) string deta hai
// ("1.3600" → "1.36", "92.0000" → "92", "1.9600" → "1.96"). Number na ho to value as-is,
// khaali ho to fallback.
export const formatOdds = (v, fallback = '-') => {
  if (v === null || v === undefined || v === '') return fallback;
  const n = Number(v);
  return Number.isFinite(n) ? String(n) : v;
};

// Admin casino profit/liability (book): no "+" on a profit, "-" on a liability,
// decimals only when the value has them (max 2), no commas (1345 / -22.5; user 2026-10-23).
export const formatBook = (v) => {
  const n = Math.round((Number(v) || 0) * 100) / 100 || 0; // `|| 0` drops -0
  return n.toLocaleString('en-IN', { maximumFractionDigits: 2, useGrouping: false });
};

// My Bets / View More stake: 1000 → "1,000", 150.5 → "150.5"; non-numbers as-is.
export const formatAmount = (v, fallback = '-') => {
  if (v === null || v === undefined || v === '') return fallback;
  const n = Number(String(v).replace(/,/g, ''));
  return Number.isFinite(n) ? n.toLocaleString('en-IN', { maximumFractionDigits: 2 }) : v;
};
